import { IDienstleistungArtInfo } from '../mgs.types';

export const DIENSTLEISTUNGSART_LIFESTYLE_ID = 1;
export const DIENSTLEISTUNGSART_FERNOST_ID = 2;
export const DIENSTLEISTUNGSART_KLASSIK_ID = 3;
export const DIENSTLEISTUNGSART_WELLFEELING_ID = 4;
export const DIENSTLEISTUNGSART_TIME4ME_ID = 5; // ehemals Gesundheitswoche
export const DIENSTLEISTUNGSART_KIDS_ID = 6;
export const DIENSTLEISTUNGSART_BALANCE_ID = 7;
export const DIENSTLEISTUNGSART_LEHRER_ID = 8;
export const DIENSTLEISTUNGSART_DYNAMIK_ID = 9; // heisst jetzt BODY (nur Umbennenung -> JR-23860)
export const DIENSTLEISTUNGSART_AESTHETIK_ID = 10;
export const DIENSTLEISTUNGSART_FITNESS_ID = 11;
export const DIENSTLEISTUNGSART_ERNAEHRUNGCHECK_ID = 12;
export const DIENSTLEISTUNGSART_FITNESS_2_ID = 13;
export const DIENSTLEISTUNGSART_ENERGIE_ID = 14;
export const DIENSTLEISTUNGSART_MINI_ID = 15;
export const DIENSTLEISTUNGSART_KIDS_TEENS_ID = 16;
export const DIENSTLEISTUNGSART_AMBULANTE_FRUEHERKENNUNG_ID = 17;
export const DIENSTLEISTUNGSART_AMBULANT_ID = 18;
export const DIENSTLEISTUNGSART_AYURVEDA_ID = 19;
export const DIENSTLEISTUNGSART_DETOX_ID = 20;
export const DIENSTLEISTUNGSART_SPECIAL_ID = 21;
export const DIENSTLEISTUNGSART_YOGA_ID = 22;
export const DIENSTLEISTUNGSART_RELAX_ID = 23;
export const DIENSTLEISTUNGSART_SOUL_ID = 24;

// NUTRIGENETIK DL's gehören zusammen (analog Fitness)
// wird über 2 Code's abgewickelt
export const DIENSTLEISTUNGSART_NUTRIGENETIK_ID = 25;
export const DIENSTLEISTUNGSART_NUTRIGENETIK_COACHING_ID = 26;
export const DIENSTLEISTUNGSART_PHARMAKOGENETIK_ID = 27;

export const DIENSTLEISTUNGSART_FIT_CARDIO_ID = 28;
export const DIENSTLEISTUNGSART_FIT_RUECKEN_ID = 29;

export const DIENSTLEISTUNGSART_INSTAHELP_ID = 32;

export const DIENSTLEISTUNGSART_MENTAL_ID = 30;

export const DIENSTLEISTUNGSART_CHECK_MYMIND_ID = 33;
export const DIENSTLEISTUNGSART_CHECK_MYBACK_ID = 34;
export const DIENSTLEISTUNGSART_CHECK_MYHEART_ID = 35;

export const DIENSTLEISTUNGSART_FIT_NUTRITION_ID = 31;
export const DIENSTLEISTUNGSART_UNDEFINED_ID = 99999;

export const DIENSTLEISTUNGSART_KIDS_OR_TEENS = [DIENSTLEISTUNGSART_KIDS_ID, DIENSTLEISTUNGSART_KIDS_TEENS_ID];

export function isNutrigenetikTeil2(art: IDienstleistungArtInfo): boolean {
  return DIENSTLEISTUNGSART_NUTRIGENETIK_COACHING_ID === art.id;
}

export function isNutrigenetikTeil1(art: IDienstleistungArtInfo): boolean {
  return DIENSTLEISTUNGSART_NUTRIGENETIK_ID === art.id;
}

export function isFitness(art: IDienstleistungArtInfo): boolean {
  return DIENSTLEISTUNGSART_FITNESS_ID === art.id;
}

export function isFitnessTeil2(art: IDienstleistungArtInfo): boolean {
  return DIENSTLEISTUNGSART_FITNESS_2_ID === art.id;
}

export function isYoga(art: IDienstleistungArtInfo): boolean {
  return DIENSTLEISTUNGSART_YOGA_ID === art.id;
}

export function isFitnessOderYoga(art: IDienstleistungArtInfo): boolean {
  return isFitnessDienstleistung(art) || isYoga(art);
}

export function isFitnessDienstleistung(art: IDienstleistungArtInfo) {
  return isFitness(art) || isFitnessTeil2(art);
}

export function getAufnahmedatumLabel(art: IDienstleistungArtInfo): string {
  if (isFitnessOderYoga(art)) {
    return 'Training Beginndatum';
  } else if (isNutrigenetikTeil1(art)) {
    return 'KIT zugesandt am';
  } else if (isNutrigenetikTeil2(art)) {
    return 'Ernährungsberatung am';
  } else {
    return 'Aufnahmedatum';
  }
}
